// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBWA6tPZwZuuYRjp9lm0Vk9z-NCD4Dactg",
  authDomain: "btui-25.firebaseapp.com",
  projectId: "btui-25",
  storageBucket: "btui-25.firebasestorage.app",
  messagingSenderId: "303902884535",
  appId: "1:303902884535:web:0739f543a72bf7d6cf0332",
  measurementId: "G-ZV6CWVR1T6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

// Initialize Auth
const auth = getAuth(app);

export { db, storage, auth };
